import * as React from 'react';
type Props = {
  className?: string;
};
export function Beef({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Beef"
      className={className}
    >
      <path
        d="M4.66989 23.5082C0.0645271 16.8296 5.68856 8.8837 12.9777 8.63776C16.5868 8.51593 19.9744 9.86634 23.6325 9.58562C27.1189 9.3182 32.3555 6.22897 35.2203 9.47081C41.3805 16.4418 12.8785 35.4126 4.66989 23.5082Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.78687 22.4372L5.26287 27.2666C5.62571 27.8777 6.25808 28.7828 7.28021 29.6267C7.28021 29.6267 8.48868 30.6245 10.1158 31.2085C14.0098 32.6062 19.9421 30.6781 20.8104 30.3879C25.9015 28.6856 29.0531 26.0447 31.218 24.2309C34.868 21.1727 35.9775 19.03 36.5167 17.3789C36.7962 16.5233 36.958 15.8639 36.9897 15.3142C37.0862 13.6422 36.4885 12.3124 36.0956 11.6031"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5531 20.8521C14.3888 20.8521 15.877 19.3639 15.877 17.5282C15.877 15.6925 14.3888 14.2045 12.5531 14.2045C10.7174 14.2045 9.22925 15.6925 9.22925 17.5282C9.22925 19.3639 10.7174 20.8521 12.5531 20.8521Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7318 16.5568L26.3345 14.5864"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
